export default __webpack_public_path__ + "static/profile-image-7e12a24451951446f760c59352b675c5.jpeg";